import React from 'react'

const Foreground = ({attrs}) =>
	<div className="block-foreground">
		<div className="block-foreground-title" dangerouslySetInnerHTML={{__html: attrs.title}}/>
		<div className="block-foreground-content" dangerouslySetInnerHTML={{__html: attrs.foregroundContent}}/>
	</div>

export default Foreground
